const sectionType = {
    ANY : 0,

    PROPOSAL : 1,

    BINDER : 2

};

angular.module('gw-um-j2js')
    .constant('sectionType', sectionType);